const ValidUserName = (password) => {
  const username_regex = /^[A-z][A-z0-9-_]{3,23}$/;
  return username_regex.test(password);
};
export default ValidUserName;
